import React from "react";

import { CellContext } from "@tanstack/react-table";

import type { LibreViewClinicPatient } from "@/models/LibreViewModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { ColumnHeader } from "@/uiKit/organisms/PatientSync/columnHeader.tsx";
import { formatNumber } from "@/utils/mathUtils.ts";

export const TIRCell: React.FC<CellContext<LibreViewClinicPatient, number | undefined>> = ({ getValue }) => {
  const value = getValue();
  return <Typography variant="body">{value !== undefined ? formatNumber(value, 0) + "%" : "-"}</Typography>;
};

export const TIRHeader: React.FC = () => <ColumnHeader translationKey="patientSync.libreviewTable.tir" />;
